import ApiService from "@/services/ApiService.js";

const state = {
    locations: []
}

const getters = {
    locations: state => state.locations
}

const mutations = {
    UPDATE_LOCATION(state, payload) {
        state.locations = payload;
    }
}

const actions = {
    setLocation({ commit }) {
        return new Promise((resolve) => {
            ApiService.getLocation(0).then(res => {
                let payload = [];
                if (res.masterProductLocationResponse.length > 0) {
                    res.masterProductLocationResponse.forEach((x) => {
                        if (x.parentId < 0) {
                            payload.push({
                                id: x.id,
                                name: x.name.trim(),
                                countries: [],
                            });
                        } else {
                            if (payload.length > 0) {
                                payload.forEach((y) => {
                                    if (x.parentId === y.id) {
                                        y.countries.push({
                                            id: x.id,
                                            name: x.name.trim(),
                                            cities: [],
                                        });
                                    }
                                    y.countries.forEach((z) => {
                                        if (x.parentId === z.id) {
                                            z.cities.push({
                                                id: x.id,
                                                name: x.name.trim(),
                                            });
                                        }
                                    });
                                });
                            }
                        }
                    });
                }
                commit('UPDATE_LOCATION', payload);
                resolve();
            }).catch(error => {
                commit('UPDATE_LOCATION', []);
                resolve();
                throw new Error(`API ${error}`);
            });
        });
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}